import { api } from '..';
export const getTipaltiUrls = () => {
  return api.tipalti.getTipaltiUrls().then(response => Promise.resolve(response.data)).catch(e => Promise.reject(e.response));
};